import { BaseModel } from "sjs-base-model";
import PlatformSourceModel from "./PlatformSourceModel.js";

export default class PlatformHitsDataModel extends BaseModel {
  //priority list hits data model
  _id = "";
  _index = "";
  _score = "";
  _source = PlatformSourceModel;

  constructor(data1) {
    super();

    this.update(data1);
  }
}
